module.exports = __webpack_public_path__ + "static/media/minigelatinas-confiteria-lara-composicion-nutricional.0685c9ff.pdf";